import { render, staticRenderFns } from "./V3Button.vue?vue&type=template&id=6823057c&scoped=true&"
import script from "./V3Button.vue?vue&type=script&lang=js&"
export * from "./V3Button.vue?vue&type=script&lang=js&"
import style0 from "./V3Button.vue?vue&type=style&index=0&id=6823057c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823057c",
  null
  
)

export default component.exports